/**
 * The technical details of a failed request, for the `details` of an `ErrorState`: the error code and the
 * request id of the backend's error envelope (what an operator quotes to find the log line). `undefined` for
 * anything that is not an `ApiException` — a plain error has neither, and inventing a code would be a lie.
 */

import { ApiException } from './api'

export function apiErrorDetails(error: unknown): string | undefined {
  if (!(error instanceof ApiException)) return undefined
  const code = error.code ?? 'UNKNOWN_ERROR'
  return error.requestId ? `${code} · ${error.requestId}` : code
}
